import { c as _c } from "react/compiler-runtime";
import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
import { Pictogram } from '@sola/ark-core/atoms/pictogram/pictogram.tsx';
import type { GraphQLLetter } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { PrimaryCta, PrimaryCtaActions, PrimaryCtaBody, PrimaryCtaHeading, PrimaryCtaIcon, PrimaryCtaText } from '../primary-cta/primary-cta.tsx';
import { usePrimaryCtaLetterRead } from './primary-cta-letter-read.logic.ts';
export const PrimaryCtaLetterRead: React.FC<{
  letters: GraphQLLetter[];
}> = t0 => {
  const $ = _c(21);
  const {
    letters
  } = t0;
  let t1;
  if ($[0] !== letters) {
    t1 = {
      letters
    };
    $[0] = letters;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    t,
    count,
    title,
    subtitle
  } = usePrimaryCtaLetterRead(t1);
  if (!letters || letters.length === 0) {
    return null;
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <PrimaryCtaIcon><Pictogram name="letter" /></PrimaryCtaIcon>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== title) {
    t3 = <PrimaryCtaHeading>{title}</PrimaryCtaHeading>;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== subtitle) {
    t4 = <PrimaryCtaText>{subtitle}</PrimaryCtaText>;
    $[5] = subtitle;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <PrimaryCtaBody>{t3}{t4}</PrimaryCtaBody>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("my:ctas.writeLetter.url");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== count || $[13] !== t) {
    t7 = t("my:primaryCtaLetterRead.cta", {
      count
    });
    $[12] = count;
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <PrimaryCtaActions><ButtonStyle variant="secondary"><a href={t6}>{t7}</a></ButtonStyle></PrimaryCtaActions>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t5 || $[19] !== t8) {
    t9 = <PrimaryCta variant="default">{t2}{t5}{t8}</PrimaryCta>;
    $[18] = t5;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};